import { reduxKey } from './constants';
export var getActiveStream = function (state) {
    return state[reduxKey] && state[reduxKey]['activeStream'];
};
export var getIsLoading = function (state) {
    return state[reduxKey] && state[reduxKey]['isLoading'];
};
export var getIsLoadingStream = function (state) {
    return state[reduxKey] && state[reduxKey]['isLoadingStream'];
};
export var isInitialized = function (state) {
    return state[reduxKey] && state[reduxKey]['isInitialized'];
};
export var getStream = function (state, streamType) {
    return state[reduxKey] && state[reduxKey][streamType + "Emotes"];
};
//# sourceMappingURL=selectors.js.map